import { ModelBase } from 'store/model-base';

export class CmsLevelMoveStart extends ModelBase {
    public static storeName: string = 'cmsLevelMoveStart';

    public pageTitle: string;
    public header: string;
    public planSixHeader: string;
    public icon5G: CmsMediaImage;
    public planSixIcon: CmsMediaImage;
    public planGroupInfo: CmsLevelMovePlanFeaturesGroup[];
    public planSixGroupInfo: CmsLevelMovePlanSixFeaturesGroup[];
    public planSixCBMGroupInfo: CmsLevelMovePlanSixFeaturesGroup[];
    public resiRecommendation: CmsLevelMoveRecommendationData;
    public cbmRecommendation: CmsLevelMoveRecommendationData;
    public timeInfo: CmsTimeInfoData;
    public cancelBtn: string;
    public upgradeBtn: string;
    public upgradeAndSwitchBtn: string;
}
